import { gql } from '@apollo/client';

export const setPaymentError = gql`mutation checkoutPaymentErrors($id: String!, $input: PaymentErrorInput!) {
  checkoutPaymentErrors(id: $id, input: $input)
}`
